<script>
	import {API,http_headers,acListCheck, getLoggedUser} from '../global.js'
	import { createEventDispatcher } from 'svelte'

	export let cliente = 0
	export let venta = 0
	export let idmoneda = 0

	let idccc = 0
	let ds_comprobantes = []
	let opencomprobantes = false
	let monedas = ['','$Ar','$Us','$Ur']
	let update = false

	const dispatch = createEventDispatcher()

	$: refresh = async()=>{
		if(parseInt(venta)===0) return []

		//select top 100 * from ctactec  where idcliente=136763 order by idccc desc
		let query = `select top 30 * from w_ventas_pagos where idw_venta = ${venta} `

		const res = await fetch(`${API}/exec-query?u=${update}`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})
			})
		const data = await res.json()

		//console.log(data)
		if(res.ok) return data.data
		else throw new Error(data)
	}

	async function getComprobantes(){
		ds_comprobantes = []
		/*
		let query = `select top 5 idccc,idcliente,idmoneda,round(haber/cotizacion,2,2) importe,cotizacion,0 as aplicado
						,(haber/cotizacion)-isnull((select sum(aplicado) from w_ventas_pagos where idccc = ctactec.idccc),0) as _saldocte
					   from ctactec  where idcliente=${cliente} order by idccc desc`
						 */
		let query = `select top 207
 idventa,tipocomprobante +letra+ ' '+ right('0000'+convert(varchar(4),NroSucursal),4)
 +'-'+ right('00000000'+convert(varchar(8),NroComprobante),9) comprobante
,convert(varchar(10),FechaComprobante ,103) fecha,total importe,referencia,observacion,idreferencia
,isnull((select sum(aplicado ) from w_ventas_pagos where idw_venta=ventas.idventa),0) aplicado
from ventas where idcliente=${cliente}`

		const res = await fetch(`${API}/exec-query?u=${update}`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})
			})
		const data = await res.json()
		if(res.ok) ds_comprobantes = data.data
		else throw new Error(data)
		opencomprobantes = true
	}

	async function verificarComprobante(){
		let query = `select sum(aplicado) from w_ventas_pagos where idccc = ${idccc}`

	}

	function close_comprobantes(){
		ds_comprobantes = []
		opencomprobantes = false
	}

	let importe_aplicado = 0
	async function agregar_comprobante(cte){
		if(cte.aplicado>0){
			// mutation
			//id,idw_venta idccc idcliente moneda importe aplicado fecha liquidado
			let reg = cte
			reg['aplicado'] = parseFloat(reg['aplicado'])
			reg['idw_venta'] = venta
			//console.log(reg['_saldocte'])
			delete reg['_saldocte']
			/* */
			const res = await fetch(`${API}/exec-mutation`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({mutation:'insert',tabname:'w_ventas_pagos',params : reg,})
			})
			const data = await res.json()
			return
		/*
			if(res.ok) ds_comprobantes = data.data
			else throw new Error(data)
		*/
			console.log(reg)
		}else{
			alert("No se indico importe a aplicar a la transaccion")
		}
	}


</script>

<div class="container">
	<button class="text-end" on:click={()=>getComprobantes()}>Agregar Pago</button>
	{#await refresh()}
		<p>Loading....</p>
	{:then rs}
		<div class="container">
			<pre>{JSON.stringify(rs,null,2)}</pre>
		</div>
	{/await}

</div>

{#if opencomprobantes}

	<div class="card" style="max-width: 700px;">
		<h5 class="card-header text-end">
			<button  on:click="{close_comprobantes}">&times;</button>
		</h5>
		<div class="card-body">
		{#each ds_comprobantes as cte, index}
			<div class="row my-2 border-bottom">
				<div class="col">{cte.comprobante}</div>
				<div class="col text-end">{cte.importe.toFixed(2)} <b>$</b></div>
				<div class="col"><input class="text-end" bind:value={cte.aplicado}></div>
				<div class="col"><button on:click={()=>agregar_comprobante(cte)}>+</button></div>
			</div>
		{/each}
		</div>
	</div>
{/if}
